import Layout2 from '@/layout/Layout2'
let ja = require('../../common/lang/ja')
let zh = require('../../common/lang/zh-CN')

export default [{
    path: '/activityCount',
    component: Layout2,
    meta: { zhtitle: zh.m.aside.nav.ACTIVITYS_SAT,jatitle:ja.m.aside.nav.ACTIVITYS_SAT },
    children: [{
        path: '',
        name: 'activityCount',
        component: () => import( /* webpackChunkName: "jp.activityCount" */ '@/merchanAdmin/activityCount/list'),
    	meta: {
    	    zhtitle: zh.m.aside.nav.ACTIVITYS_SAT,
    	    jatitle: ja.m.aside.nav.ACTIVITYS_SAT,
    	    pername: "activity_statistics"
    	}
    }]
}]